import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  ChevronDownIcon,
  Paper,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const ControlledAccordion = () => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Controlled Accordion
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              'import React from "react";\n' +
              'import { Typography } from "@mui/material";\n' +
              'import Accordion from "@mui/material/Accordion";\n' +
              'import AccordionSummary from "@mui/material/AccordionSummary";\n' +
              'import AccordionDetails from "@mui/material/AccordionDetails";\n' +
              'import { ChevronDownIcon } from "../../../common/Icons/Icons";\n' +
              "\n" +
              "const Index = () => {\n" +
              "  return (\n" +
              "<Accordion\n" +
              '                expanded={expanded === "panel1"}\n' +
              '                onChange={handleChange("panel1")}\n' +
              "              >\n" +
              "                <AccordionSummary\n" +
              "                  expandIcon={\n" +
              '                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />\n' +
              "                  }\n" +
              '                  aria-controls="panel1bh-content"\n' +
              '                  id="panel1bh-header"\n' +
              "                >\n" +
              "                  <Typography\n" +
              '                    variant={"button"}\n' +
              '                    color={"text.secondary"}\n' +
              '                    sx={{ textTransform: "normal" }}\n' +
              "                  >\n" +
              "                    General settings\n" +
              "                  </Typography>\n" +
              '                  <Typography variant="body2" sx={{ color: "text.secondary" }}>\n' +
              "                    I am an accordion\n" +
              "                  </Typography>\n" +
              "                </AccordionSummary>\n" +
              "                <AccordionDetails>\n" +
              "                  <Typography>\n" +
              "                    Nulla facilisi. Phasellus sollicitudin nulla et quam mattis\n" +
              "                    feugiat. Aliquam eget maximus est, id dignissim quam.\n" +
              "                  </Typography>\n" +
              "                </AccordionDetails>\n" +
              "              </Accordion>\n" +
              "              <Accordion\n" +
              '                expanded={expanded === "panel2"}\n' +
              '                onChange={handleChange("panel2")}\n' +
              "              >\n" +
              "                <AccordionSummary\n" +
              "                  expandIcon={\n" +
              '                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />\n' +
              "                  }\n" +
              '                  aria-controls="panel2bh-content"\n' +
              '                  id="panel2bh-header"\n' +
              "                >\n" +
              "                  <Typography\n" +
              '                    variant={"button"}\n' +
              '                    color={"text.secondary"}\n' +
              '                    sx={{ textTransform: "normal" }}\n' +
              "                  >\n" +
              "                    Users\n" +
              "                  </Typography>\n" +
              '                  <Typography variant="body2" sx={{ color: "text.secondary" }}>\n' +
              "                    You are currently not an owner\n" +
              "                  </Typography>\n" +
              "                </AccordionSummary>\n" +
              "                <AccordionDetails>\n" +
              "                  <Typography>\n" +
              "                    Donec placerat, lectus sed mattis semper, neque lectus\n" +
              "                    feugiat lectus, varius pulvinar diam eros in elit.\n" +
              "                    Pellentesque convallis laoreet laoreet.\n" +
              "                  </Typography>\n" +
              "                </AccordionDetails>\n" +
              "              </Accordion>\n" +
              "              <Accordion\n" +
              '                expanded={expanded === "panel3"}\n' +
              '                onChange={handleChange("panel3")}\n' +
              "              >\n" +
              "                <AccordionSummary\n" +
              "                  expandIcon={\n" +
              '                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />\n' +
              "                  }\n" +
              '                  aria-controls="panel3bh-content"\n' +
              '                  id="panel3bh-header"\n' +
              "                >\n" +
              "                  <Typography\n" +
              '                    variant={"button"}\n' +
              '                    color={"text.secondary"}\n' +
              '                    sx={{ textTransform: "normal" }}\n' +
              "                  >\n" +
              "                    Advanced settings\n" +
              "                  </Typography>\n" +
              '                  <Typography variant="body2" sx={{ color: "text.secondary" }}>\n' +
              "                    Filtering has been entirely disabled for whole web server\n" +
              "                  </Typography>\n" +
              "                </AccordionSummary>\n" +
              "                <AccordionDetails>\n" +
              "                  <Typography>\n" +
              "                    Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.\n" +
              "                    Integer sit amet egestas eros, vitae egestas augue. Duis vel\n" +
              "                    est augue.\n" +
              "                  </Typography>\n" +
              "                </AccordionDetails>\n" +
              "              </Accordion>\n" +
              "              <Accordion\n" +
              '                expanded={expanded === "panel4"}\n' +
              '                onChange={handleChange("panel4")}\n' +
              "              >\n" +
              "                <AccordionSummary\n" +
              "                  expandIcon={\n" +
              '                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />\n' +
              "                  }\n" +
              '                  aria-controls="panel4bh-content"\n' +
              '                  id="panel4bh-header"\n' +
              "                >\n" +
              "                  <Typography\n" +
              '                    variant={"button"}\n' +
              '                    color={"text.secondary"}\n' +
              '                    sx={{ textTransform: "normal" }}\n' +
              "                  >\n" +
              "                    Personal data\n" +
              "                  </Typography>\n" +
              "                </AccordionSummary>\n" +
              "                <AccordionDetails>\n" +
              "                  <Typography>\n" +
              "                    Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.\n" +
              "                    Integer sit amet egestas eros, vitae egestas augue. Duis vel\n" +
              "                    est augue.\n" +
              "                  </Typography>\n" +
              "                </AccordionDetails>\n" +
              "              </Accordion>" +
              "  );\n" +
              "};\n"
            }
          >
            <div>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
              >
                <AccordionSummary
                  expandIcon={
                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography
                    variant={"button"}
                    color={"text.secondary"}
                    sx={{ textTransform: "normal" }}
                  >
                    General settings
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    I am an accordion
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Nulla facilisi. Phasellus sollicitudin nulla et quam mattis
                    feugiat. Aliquam eget maximus est, id dignissim quam.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  expandIcon={
                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />
                  }
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Typography
                    variant={"button"}
                    color={"text.secondary"}
                    sx={{ textTransform: "normal" }}
                  >
                    Users
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    You are currently not an owner
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Donec placerat, lectus sed mattis semper, neque lectus
                    feugiat lectus, varius pulvinar diam eros in elit.
                    Pellentesque convallis laoreet laoreet.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
              >
                <AccordionSummary
                  expandIcon={
                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />
                  }
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                >
                  <Typography
                    variant={"button"}
                    color={"text.secondary"}
                    sx={{ textTransform: "normal" }}
                  >
                    Advanced settings
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Filtering has been entirely disabled for whole web server
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.
                    Integer sit amet egestas eros, vitae egestas augue. Duis vel
                    est augue.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel4"}
                onChange={handleChange("panel4")}
              >
                <AccordionSummary
                  expandIcon={
                    <ChevronDownIcon fontSize="small" color={"text.tertiary"} />
                  }
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                >
                  <Typography
                    variant={"button"}
                    color={"text.secondary"}
                    sx={{ textTransform: "normal" }}
                  >
                    Personal data
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.
                    Integer sit amet egestas eros, vitae egestas augue. Duis vel
                    est augue.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ControlledAccordion;
